import React from 'react';
import { useOutletContext, useParams } from 'react-router';

import { ContactDto } from '@/api/generated';
import { ContactDetailsContactInfo } from '@/views/contactsDetails/components/contactInfo/section/ContactDetailsContactInfo.comp.tsx';

export const ContactDetailsContactInfoTab: React.FC = () => {
  const { contactId } = useParams();
  const contactDetails = useOutletContext<ContactDto>();

  if (!contactId) {
    return null;
  }

  return (
    <ContactDetailsContactInfo
      contactId={Number.parseInt(contactId)}
      contactInfos={contactDetails.contactInfos ?? []}
    />
  );
};
